import { AppointmentDispatchTypes, useAppointmentDispatch, useAppointmentStateUnsafe } from '../../context/Appointment/appointment';
import { useNavigate } from 'react-router-dom';
import { useKioskState } from '../../context/Kiosk/kiosk';
import { useLocale, useLocalization, useLocalizationExtension } from '../../context/Localization/localization';
import { GMAppointmentName } from '../../controls/AppointmentName';
import { CTAButton } from '../../controls/ButtonBase';
import { Heading } from '../../controls/Heading/Heading';
import { Spinner } from '../../controls/Spinner/Spinner';
import { ScrollableBody } from '../Layout/ScrollableBody';
import { AppRoutePaths } from '../../helpers/Routes';
import { GMButtonGroup } from '../../controls/ButtonGroup';
import { GMRoundedIcon, GMSizedIcon } from '../../controls/Icon';
import { Locales } from '../../context/Localization/localization.types';

export const ContinueAppointment = (props: { onProceed: () => void; onStartOver: () => void; }) => {
    const appointmentDispatch = useAppointmentDispatch();
    const navigate = useNavigate();
    const {
        dealer: { name },
    } = useKioskState();
    const Localization = useLocalization();
    const { formatAsString } = useLocalizationExtension();
    const appointment = useAppointmentStateUnsafe();
    const currentLocale = useLocale();

    const startOver = () => {
        // Remove the appointment only if we have one.
        appointmentDispatch({ type: AppointmentDispatchTypes.RemoveAndRecordInitialInteraction });
        navigate(AppRoutePaths.Customer, { replace: true });
        props.onStartOver();
    };

    if (!appointment) {
        return <Spinner />;
    }

    return (
        <ScrollableBody
            heading={
                <Heading
                    primaryHeading={
                        <>
                            <GMAppointmentName />
                            {`, ${formatAsString(Localization.WelcomeToDealership, name)}`}
                        </>
                    }
                    secondaryHeading={Localization.LetsContinueWhereYouLeftOff}
                    showMustache
                />
            }
            proceedButtons={
                <GMButtonGroup
                    alignment={'center'}
                    buttons={[
                        (
                            <CTAButton
                                styleType={'primary'}
                                onClick={props.onProceed}
                                label={Localization.LetsGo}
                                kioskOptions={{
                                    square: true,
                                    wider: currentLocale === Locales.fr,
                                }}
                                id={Localization.LetsGo}
                                ariaLabel={Localization.LetsGo}
                            />
                        ),
                        (
                            <CTAButton
                                styleType={'secondary'}
                                onClick={startOver}
                                label={Localization.IWantToStartOver}
                                kioskOptions={{
                                    square: true,
                                    wider: currentLocale === Locales.fr,
                                    squareOptions: {
                                        roundedIcon: (
                                            <GMRoundedIcon
                                                themeType={'primary'}
                                                allowInvertedPrimary
                                                roundedBackgroundSize={'large'}
                                            >
                                                <GMSizedIcon iconSize={'custom'} iconType={'No'} />
                                            </GMRoundedIcon>
                                        ),
                                    },
                                }}
                                id={Localization.IWantToStartOver}
                                ariaLabel={Localization.IWantToStartOver}
                            />
                        ),
                    ]}
                />
            }
            unsetButtons
        />
    );
};
